<template>
    <div class="container-fluid">
        <div
            v-if="currentSlide"
            class="herosection"
            :style="{
                backgroundImage: `url('${currentSlide.image}')`
            }"
            >
            <NavbarSection />

             <!-- Left Arrow -->
            <button class="nav-arrow left" @click="prevSlide">
                ‹
            </button>

            <!-- Right Arrow -->
            <button class="nav-arrow right" @click="nextSlide">
                ›
            </button>

            <transition name="fade-slide" mode="out-in">
                <div class="heroWriteup" :key="currentIndex">
                <h2>{{ currentSlide.title }}</h2>
                <p>{{ currentSlide.description }}</p>

                <div class="authbuttons">
                    <button class="login" @click="joinNow">
                        <b>Join Now</b>
                        <ArrowRight />
                    </button>

                    <button class="register" @click="bookCourt">
                        <b>Book a Court</b>
                        <Bookmark />
                    </button>
                </div>
                </div>
            </transition>

            <div class="hero-dots">
                <span
                v-for="(_, index) in slides"
                :key="index"
                :class="{ active: index === currentIndex }"
                @click="currentIndex = index"
                ></span>
            </div>
        </div>
    <HighLights />
    <div id="club-events">
        <SocialEvents />
    </div>
    
    <SportSections />
    <p>&nbsp;</p>
    <h2>Programs Overview</h2>
    <p>Discover our comprehensive range of tennis programs designed for players of all ages and skill levels</p>
    <ProgramOverviewFour />
    <div class="become-member">
        <h2>Become a Member</h2>
        <p>We're crafting a simple membership experience, register your interest while we welcome you to LLTC1895 Tennis Community.</p>
        <button @click="registerInterest()">
            <p>Register Interest</p>
            <MoveUpRight />
        </button>
        <div class="bgelement-right">
            <img src="../assets/images/sports/bgelement.png" alt="">
        </div>
        <div class="bgelement-left">
            <img src="../assets/images/sports/bgelementleft.png" alt="">
        </div>
    </div>
    <div>
        <MediaGallery />
    </div>
    <div class="stay-connected">
        <h2>Stay Connected with Lagos Lawn <span style="color: #094923;">Tennis Club</span></h2>
        <p>Subscribe to our newsletter for the latest news, events, and exclusive member updates</p>

        <div class="subscribe-form">
            <input type="email" v-model="emailAddress" placeholder="Email Address">
            <button @click="subscribe">Subscribe</button>
        </div>
        <div style="display: flex; justify-content: center; gap: 20px; margin-top: 2rem; align-items: center;">
        <!-- Weekly -->
        <div style="display: flex; gap: 10px; align-items: center;">
            <input type="checkbox" id="weekly" v-model="weeklyChecked" />
            <label for="weekly" style="font-size: 16px; color: #060B13; font-weight: 400;">
            Weekly Updates
            </label>
        </div>

        <!-- Monthly -->
        <div style="display: flex; gap: 10px; align-items: center;">
            <input type="checkbox" id="monthly" v-model="monthlyChecked" />
            <label for="monthly" style="font-size: 16px; color: #060B13; font-weight: 400;">
            Monthly Updates
            </label>
        </div>
        </div>

        <div class="bg-img">
            <img src="../assets/images/sports/stayconnected-bg.png" alt="">
        </div>
    </div>
    <SocialFeed />
    <FooterSection />
</div>
</template>

<script setup>
/* eslint-disable */
import FooterSection from '@/components/FooterSection.vue';
import HighLights from '@/components/HighLights.vue';
import MediaGallery from '@/components/MediaGallery.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import ProgramOverviewFour from '@/components/ProgramOverviewFour.vue';
import SocialEvents from '@/components/SocialEvents.vue';
import SocialFeed from '@/components/SocialFeed.vue';
import SportSections from '@/components/SportSections.vue';
import router from '@/router';
import { ArrowRight, Bookmark, MoveUpRight } from "lucide-vue-next"
import { ref, computed, onMounted, onUnmounted, onBeforeUnmount, nextTick } from "vue";
import axios from 'axios';

let base_url = process.env.VUE_APP_BASE_LIVE_URL
//let base_url = "http://localhost:8888/lltc_backend/";
const dataList = ref([]);
const title = ref('');
const description = ref('');
const image = ref('');
const logoImage = ref('');
const emailAddress = ref('')
const monthlyChecked = ref()
const weeklyChecked = ref('')

const slides = ref([]);

const currentIndex = ref(0);
let interval = null;

/* SAFELY get active slide */
const currentSlide = computed(() => {
  if (!slides.value.length) return null;
  if (!slides.value[currentIndex.value]) return slides.value[0];
  return slides.value[currentIndex.value];
});

/* Auto slide */
const nextSlide = () => {
  if (slides.value.length < 2) return;
  currentIndex.value = (currentIndex.value + 1) % slides.value.length;
};

// const nextSlide = () => {
//   currentIndex.value = (currentIndex.value + 1) % slides.value.length;
// };


// Action methods
const subscribe = async () => {
    try {

        // Validate that at least one is checked
        if (!weeklyChecked.value && !monthlyChecked.value) {
        alert("Please select a subscription type (Weekly or Monthly)");
        return;
        }

        // Make the signup API request
        const response = await axios.post('/subscribe.php', {
             emailAddress: emailAddress.value,
             weeklyChecked: weeklyChecked.value,
             monthlyChecked: monthlyChecked.value
        });

        alert(response.data.message);
        emailAddress.value = ""
        monthlyChecked.value = ""
        weeklyChecked.value = ""
            
    } catch (error) {
        alert(error.response ? error.response.data.message : error.message);
        console.error('Error:', error.response ? error.response.data : error.message);
    }
}

/* API banners */
const listGallery = async () => {
  try {
    const response = await axios.get("/list_site_banner.php");

    if (Array.isArray(response.data?.data)) {
      slides.value = response.data.data.map(item => ({
        title: item.title,
        description: item.description,
        image: `${base_url}${item.banner_image}`
      }));
      currentIndex.value = 0;
    }
  } catch (error) {
    console.error("Banner fetch failed:", error.message);
  }
};
const listLogo = async () => {
  try {
    const response = await axios.get('/logo_lists.php', { });
   const logoData = response.data.data[0];
    logoImage.value = `${base_url}${logoData.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

onMounted( async () => {
  await listGallery();
  await listLogo();
  interval = setInterval(nextSlide, 5000);
  
});

onUnmounted(() => {
  clearInterval(interval);
});

onBeforeUnmount( async () => {
  
});

const registerInterest = () => {
    router.push("/application-forms")
    .then(() => {
      // Wait a tick to allow DOM to render, then scroll
      nextTick(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    })
    .catch(err => {
      // ignore NavigationDuplicated error in older versions
      console.error(err);
    });
}

const joinNow = () =>{
    router.push("/application-forms")
}

const bookCourt = () => {
    router.push("/book-a-court")
}
const viewMoreEvents = () => {
    router.push("/social-event")
}
</script>

<style lang="scss" scoped>

.herosection {
  height: 924px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

/* Arrow buttons */
.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  border: none;
  font-size: 36px;
  padding: 0px 16px;
  cursor: pointer;
  z-index: 10;
  border-radius: 50%;
}

.nav-arrow.left {
  left: 30px;
}

.nav-arrow.right {
  right: 30px;
}

.nav-arrow:hover {
  background: rgba(0, 0, 0, 0.7);
}

/* Text animation */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(25px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-25px);
}

/* Dots */
.hero-dots {
  position: absolute;
  bottom: 40px;
  left: 80px;
  display: flex;
  gap: 10px;
}

.hero-dots span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  cursor: pointer;
}

.hero-dots span.active {
  background: #fff;
}


.herosection {
    border-radius: 20px;
    //background-image: url('../assets/images/HeroBg.png');
    background-size: cover;
    height: 924px;
    //padding: 10px;
    position: relative;
    width: 100%;
    padding:1.5rem 4rem 0 4rem;

    .heroWriteup {
        position: absolute;
        max-width: 750px;
        text-align: left;
        bottom: 10%;
        left: 18%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: start;
        align-items: start;
        color: white;
        padding:0 0 0 7rem;

        h2 {
            font-size: 30px;
            font-weight: bold;
            font-family: 'Comic Sans MS';
            color: #F5F5F5 !important;
        }

        p {
            font-size: 18px;
            font-weight: bold;
            font-family: 'Comic Sans MS';

        }
    }
}

.authbuttons {
    display: flex;
    gap: 1rem;

    .login {
        background-color: #2A5237;
        border: 0px solid #0000001f;
        color: #fff;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 5px 20px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .login:hover {
        border: 2px solid #ed4e24;
    }

    .register {
        background-color: #ed4e24;
        border: 2px solid #0000001f;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 10px 20px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .register:hover {
        background-color: #c63d1c;
    }
}

.become-member {
    background-color: #094923;
    max-width: 80%;
    margin: auto;
    margin-top: 5rem;
    border-radius: 24px;
    padding: 20px;
    height: 479px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;

    .bgelement-right {
        position: absolute;
        top: 0;
        right: 0;
    }

    .bgelement-left {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    h2 {
        font-size: 26px;
        color: #fff;
        font-weight: 500;
        margin: 2rem 0;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 16px;
        color: #fff;
        font-weight: 300;
        max-width: 569px;
        /* margin: 2rem 0; */
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #FFFFFF29;
        border: 1px solid white;
        padding: 10px 20px;
        border-radius: 30px;
        color: white;
        gap: 10px;
        margin-top: 1rem;

        p {
            color: white;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            cursor: pointer;
            transition: 0.3s ease;
            padding: 0%;
            margin: 0%;
        }
    }
}

.stay-connected {
    position: relative;
    height: 495px;
    padding-top: 100px;
}

.stay-connected .bg-img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: -1;
}

.stay-connected .bg-img img {
    width: 100%;
    height: auto;
    display: block;
}

.stay-connected h2 {
    font-size: 36px;
    color: #000000;
    font-weight: 500;
    margin: auto;
    font-family: "Open Runde", sans-serif;
    text-align: center;
    max-width: 600px;
}

.stay-connected p {
    font-size: 16px;
    color: #555555;
    font-weight: 400;
    max-width: 681px;
    margin: auto;
    font-family: "Open Runde", sans-serif;
    text-align: center;
}

.subscribe-form {
    background-color: #fff;
    border: 1px solid #ED4E242E;
    width: 418px;
    height: 50px;
    border-radius: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
    padding-right: 4px;
    margin: auto;
    margin-top: 20px;

    input {
        border: none;
        outline: none;
        width: 100%;
        height: 100%;
        border-radius: 30px;
        padding-left: 8px;
        font-size: 16px;
    }

    button {
        background-color: #ED4E24;
        color: white;
        padding: 10px 20px;
        border-radius: 30px;
        border: none;
    }
}


@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

        .heroWriteup {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
            align-items: center;
            color: white;
            padding:0 0 0 0rem;

            h2 {
                font-size: 32px;
                /* shrink a bit for small screens */
                font-weight: 700;
                font-family: "Open Runde", sans-serif;
            }

            p {
                font-size: 16px;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
                padding: 1.2rem;
            }
        }

        .authbuttons {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .login {
                background-color: #2A5237;
                border: 0px solid #0000001f;
                color: #ffffff;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .login:hover {
                border: 2px solid #ed4e24;
            }

            .register {
                background-color: #ed4e24;
                border: 2px solid #0000001f;
                color: white;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .register:hover {
                background-color: #c63d1c;
            }
        }

    }

    .become-member {
        background-color: #094923;
        max-width: 100%;
        margin: auto;
        margin-top: 5rem;
        border-radius: 24px;
        padding: 20px;
        height: 479px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        h2 {
            font-size: 26px;
            color: #fff;
            font-weight: 500;
            margin: 2rem 0;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 16px;
            color: #fff;
            font-weight: 300;
            max-width: 100%;
            /* margin: 2rem 0; */
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }
    }

    .stay-connected {
        position: relative;
        height: auto;
        padding-top: 20px;
    }

    .subscribe-form {
        max-width: 100%;
    }
}
</style>
